import { EntityState, createEntityAdapter, EntityId } from "@reduxjs/toolkit";

import { Device } from "types/Device";

export const devicesAdapter = createEntityAdapter<Device>({
    sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export const initialState: EntityState<Device, EntityId> =
    devicesAdapter.getInitialState();
